import {
  getModuleTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import Moment from 'moment'
import moduleConfig from '../../config'

const __tc = getRootPluaralTranslator()
const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const ComputerProperyFieldMap = () => ({
  computer_property_group: {
    title: __tc('computer_property_group'),
    fields: [
      {
        key: generateId(),
        paramName: 'osName',
        name: __tc('os_name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'osVersion',
        name: __tc('os_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'servicePackName',
        name: __mtc('service_pack_name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'osLicenceKey',
        name: __tc('os_licence_key'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'osManufacturer',
        name: __tc('os_manufacturer'),
        inputType: 'manufacturer',
      },
      {
        key: generateId(),
        paramName: 'osArchitecture',
        name: __tc('os_architecture'),
        inputType: 'dropdown',
        contextOptionKey: 'osArchitectureOptions',
      },
      {
        key: generateId(),
        paramName: 'bootupState',
        name: __mtc('boot_status'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'memorySize',
        name: __tc('memory_size'),
        inputType: 'bytes',
      },
      {
        key: generateId(),
        paramName: 'diskSize',
        name: __tc('disk_size'),
        inputType: 'bytes',
      },
      {
        key: generateId(),
        paramName: 'cpuSpeed',
        name: __tc('cpu_speed'),
        inputType: 'hertz',
      },
      {
        key: generateId(),
        paramName: 'cpuCoreCount',
        name: __tc('cpu_core_count'),
        inputType: 'number',
      },
      {
        key: generateId(),
        paramName: 'partOfDomain',
        name: __mtc('part_of_domain'),
        inputType: 'boolean',
      },
      {
        key: generateId(),
        paramName: 'domainName',
        name: __tc('domain_name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'numberOfLogicalProcessors',
        name: __mtc('number_of_logical_processors'),
        inputType: 'number',
      },
      {
        key: generateId(),
        paramName: 'numberOfProcessors',
        name: __mtc('number_of_processors'),
        inputType: 'number',
      },
      {
        key: generateId(),
        paramName: 'pcSystemType',
        name: __mtc('pc_system_type'),
        inputType: 'dropdown',
        contextOptionKey: 'pcSystemTypeOptions',
      },
      {
        key: generateId(),
        paramName: 'lastLoggedInUser',
        name: __tc('last_logged_in_user'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'activationStatus',
        name: __tc('activation_status'),
        inputType: 'dropdown',
        contextOptionKey: 'activationStatusOptions',
      },
      {
        key: generateId(),
        paramName: 'parentVmHost',
        name: __tc('parent_vm_host'),
        inputType: 'hardwareAssetPicker',
      },
      {
        key: generateId(),
        paramName: 'chassisType',
        name: __tc('chassis_type'),
        inputType: 'text',
      },

      {
        key: generateId(),
        paramName: 'displayVersion',
        name: __mtc('display_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'buildNo',
        name: __mtc('build_no'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'lastRebootTime',
        name: __tc('last_reboot_time'),
        inputType: 'dateTime',
        rules: {
          max_date: Moment().valueOf(),
        },
      },
    ],
  },
})
